export function calculateLeadScore(lead) {
  let score = 0;

  if (lead.companySize === "1000+") score += 40;
  else if (lead.companySize === "251-1000") score += 30;
  else if (lead.companySize === "51-250") score += 20;
  else if (lead.companySize === "1-50") score += 10;

  if (lead.interest?.toLowerCase().includes("gap analysis")) score += 25;
  if (lead.message && lead.message.length > 20) score += 15;
  if (lead.industry) score += 10;

  return Math.min(score, 100);
}

export function getLeadTemperature(score) {
  if (score >= 80) return "Hot";
  if (score >= 50) return "Warm";
  return "Cold";
}